


const AGENCIES_QUERY_URI = '/p/api/car-categories';


export const CarCategoriesApi = {
    async getAll() {
        const response = await axios.get(`${AGENCIES_QUERY_URI}`);
        return response.data;
    },

};
